module.exports = __webpack_public_path__ + "static/media/5.40de8186.png";